// RegistrationComplete.jsx
import React, { useEffect, useRef } from 'react';
import { startCelebration } from '../utils/effects/celebration';
import { finalizeRegistration } from '../api/user';

const RegistrationComplete = ({ token, mainParticipantId }) => {
  const hasFinalizedRef = useRef(false);
  useEffect(() => {
  // Prevent double execution in React 18 StrictMode
  if (hasFinalizedRef.current) return;
  hasFinalizedRef.current = true;

  startCelebration();

  const callEndpoint = async () => {
    if (!token) {
      console.warn('No registration token available');
      return;
    }

    try {
      const response = await finalizeRegistration({
        registration_token: token,
      });
      console.log('Registration finalized:', response);
    } catch (error) {
      console.error('Error finalizing registration:', error);
    }
  };

  callEndpoint();
}, [token]);
; // re-run if token changes

  return (
    <div style={styles.container}>
      <h3 style={styles.heading}>¡Registro completo con éxito!</h3>
      <p style={styles.message}>Recibirás un correo electrónico con los siguientes pasos.</p>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    backgroundColor: '#f0fdf4',
    borderRadius: '8px',
    border: '1px solid #d1fae5',
    maxWidth: '400px',
    margin: '2rem auto',
    textAlign: 'center',
  },
  heading: {
    color: '#16a34a',
    marginBottom: '0.5rem',
  },
  message: {
    color: '#065f46',
  },
};

export default RegistrationComplete;
